import React from 'react'

import Question from '../components/Question/Question'
import TitleAndMetaTags from '../components/TitleAndMetaTags/TitleAndMetaTags'

export default function Home() {

	return (
		<>
			<TitleAndMetaTags />
			<Question />
		</>
	)
}
